import { render, staticRenderFns } from "./SwatchColorType.vue?vue&type=template&id=e4b6e418"
import script from "./SwatchColorType.vue?vue&type=script&lang=ts"
export * from "./SwatchColorType.vue?vue&type=script&lang=ts"
import style0 from "./SwatchColorType.vue?vue&type=style&index=0&id=e4b6e418&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports